import axios from 'axios';
import { LEAD_SEND_ACTION, transitionLeads } from '../../../actions/publicWeb/naPersonalLoansCallMeBack';
import {
    getCellphoneNumberValue,
    getEmployerNameValue,
    getEmploymentStatusValue,
    getFirstNameValue,
    getIdNumberValue,
    getPayslipValue,
    getProductValue,
    getSurnameValue,
    getTownValue,
    getWageFrequencyValue,
} from '../../../selectors/publicWeb/naPersonalLoansCallMeBack';

export const leadsService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();

    (async () => {
        if (action.type === LEAD_SEND_ACTION) {
            await sendToEmail(store, state);
        }
    })();

    return result;
};

async function sendToEmail(store, state) {
    store.dispatch(transitionLeads.submitting());

    const bodyParams = {
        sourceEmailAddress: 'noreply@oldmutual.com',
        toEmailAdrress: 'NamibiaLeads@oldmutual.com',
        emailCampaignCode: 'Nam-PersonalLoan-WB',
        subject: 'Personal Loan Application',
        type: 'namPersonalLoans',
        source: 'MyOldMutualPublicWebsite',
        firstName: getFirstNameValue(state).value,
        surname: getSurnameValue(state).value,
        idNumber: getIdNumberValue(state).value,
        cellphoneNumber: getCellphoneNumberValue(state).value,
        town: getTownValue(state).value,
        employmentStatus: getEmploymentStatusValue(state).value,
        wageFrequency: getWageFrequencyValue(state).value,
        receivesPayslip: getPayslipValue(state).value,
        employerName: getEmployerNameValue(state).value,
    };

    try {
        await axios.post('/om-api/call-me-back/call-me-back-mail', bodyParams, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        store.dispatch(transitionLeads.success());
    } catch (e) {
        store.dispatch(transitionLeads.error());
    }
}
